(function() {
    /* Waypoints sticky header menu */
    if ($('.header.js-header').length) { // No .header on MAPI
        var waypoint = new Waypoint({
            element: $('.header.js-header'),
            handler: function(direction) {
                var navElement = $('.top-nav-sticky');
                if (direction === 'down') {
                    $('body').addClass('sticky-nav-on');
                    navElement.removeClass("hide");
                } else {
                    $('body').removeClass('sticky-nav-on');
                    navElement.addClass("hide");
                }
            },
            offset: function() {
                return  - $(this.element).height();
            }
        });
    }

    function openLeftMenu() {
        $('body').addClass('hamburger-open');
    }

    function closeLeftMenu() {
        $('body').removeClass('hamburger-open');
    }

    function isLeftMenuOpen() {
        return $('body').hasClass('hamburger-open');
    }

    $('.hamburger-open-button').click(function(e) {
        e.preventDefault();
        e.stopPropagation();

        openLeftMenu();
    });

    $('.hamburger-close-button').click(closeLeftMenu);

    $('.page-wrapper').on('click', function(e) {
        var $target = $(e.target);
        if (isLeftMenuOpen() && !$target.closest('.left-nav').length) {
            closeLeftMenu();
        }
    });

    $('.header-search-open-button').click(function(e) {
        e.preventDefault();
        $('.header__content').addClass('header__content--search-visible');
        $('.header__content .nav-search__keywords').select().focus();
    });
    $('.header-search-close-button').click(function(e) {
        e.preventDefault();
        $('.header__content').removeClass('header__content--search-visible');
    });

    $('.nav-editions-open-button').click(function(e) {
        e.preventDefault();

        $('body').addClass('nav-editions-dropdown-open');
    });
    $('.nav-editions-close-button').click(function(e) {
        e.preventDefault();

        $('body').removeClass('nav-editions-dropdown-open');
    });
})();